import React, { PropsWithChildren } from "react";
import cs from "classnames";

import { trimText } from "../../../lib/helpers/trimText";
import {
  calculateTopOffset,
  normalizeTooltipScaleFactor,
} from "../../../lib/helpers/calculateTopOffset";

const baseWidth = 180;
const baseHeight = 43.75;

export const TooltipName = ({
  name,
  className,
  isBooked,
  scaleFactor = 0.7,
  sizeRatio = 1,
}: PropsWithChildren<{
  name: string;
  className?: string;
  isBooked?: boolean;
  scaleFactor?: number;
  sizeRatio?: number;
}>) => {
  const normalizedScaleFactor = normalizeTooltipScaleFactor(scaleFactor);

  // sizeRatio lowers the size of the tooltip for client apps
  const scaledWidth = baseWidth * normalizedScaleFactor * sizeRatio;
  const scaledHeight = baseHeight * normalizedScaleFactor * sizeRatio;

  return (
    <svg
      width={scaledWidth}
      height={scaledHeight}
      viewBox="0 0 180 50"
      style={{
        marginTop: calculateTopOffset(scaleFactor),
      }}
    >
      <text
        x="50%"
        y="40%"
        className={cs(className, {
          booked: isBooked,
        })}
      >
        {trimText(name, 18)}
      </text>
    </svg>
  );
};
